/* eslint-disable jsx-a11y/anchor-has-content */

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';
import { IconGeneric, Button, useFiltersContext } from '@spotahome/ui-library';

import './Paginator.scss';
import adUrlService from '../../utils/ad-url-service';

const Paginator = ({
  previousPage = null,
  nextPage = null,
  previousButtonDisabled = false,
  nextButtonDisabled = false,
  onPreviousButtonClick = () => {},
  onNextButtonClick = () => {},
  locationString = ''
}) => {
  const { filters } = useFiltersContext();

  const getPageUrl = page => {
    return adUrlService.getSearchUrlFromFilters(locationString, {
      ...filters,
      page
    });
  };
  const isExperiment =
    useSoyuzExperiment('MainCTAsLookAndFeel').get('behaviour') === 'variant';

  const classes = classNames('paginator', {
    'paginator--new-buttons': isExperiment
  });

  const prevPageUrl =
    previousButtonDisabled || !previousPage ? null : getPageUrl(previousPage);
  const nextPageUrl =
    nextButtonDisabled || !nextPage ? null : getPageUrl(nextPage);

  return (
    <div className={classes}>
      <Button
        fullWidth
        color="tertiary"
        size="large"
        onClick={onPreviousButtonClick}
        dataTest="paginator-btn-prev"
        disabled={previousButtonDisabled}
        className="paginator__button"
      >
        {prevPageUrl ? (
          <span>
            <IconGeneric name="angle-left" /> {trans('paginator.label.prev')}
          </span>
        ) : (
          <a href={prevPageUrl}>
            <IconGeneric name="angle-left" /> {trans('paginator.label.prev')}
          </a>
        )}
      </Button>
      <Button
        color="tertiary"
        size="large"
        fullWidth
        onClick={onNextButtonClick}
        dataTest="paginator-btn-next"
        disabled={nextButtonDisabled}
        className="paginator__button"
      >
        {nextPageUrl ? (
          <span>
            {trans('paginator.label.next')} <IconGeneric name="angle-right" />
          </span>
        ) : (
          <a href={nextPageUrl}>
            {trans('paginator.label.next')} <IconGeneric name="angle-right" />
          </a>
        )}
      </Button>
    </div>
  );
};

Paginator.propTypes = {
  previousButtonDisabled: PropTypes.bool,
  nextButtonDisabled: PropTypes.bool,
  onPreviousButtonClick: PropTypes.func,
  onNextButtonClick: PropTypes.func,
  previousPage: PropTypes.number,
  nextPage: PropTypes.number,
  locationString: PropTypes.string
};

export default Paginator;
